import React from 'react';
import * as Fab from './Fab';
import * as TextField from './TextField';
import Typography from '@material-ui/core/Typography';

export default function ContactForm(props) {
    const [firstNameValid, setFirstNameValid] = React.useState(false);
    const [emailValid, setEmailValid] = React.useState(false);

    const handleFirstNameChange = event => {
        if (event.target.value.length > 0) {
            props.setFirstName(event.target.value);
        }
        setFirstNameValid(event.target.value.length > 0);
    }
    const handleEmailChange = event => {
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(event.target.value)) {
            setEmailValid(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(event.target.value));
            props.setEmail(event.target.value);
        }
    }
	const handlePrev = () => {
		window.location.reload();
	}
    return (
        <>
            <div className="instructions">
                <div className="container">
                    <Typography variant="subtitle1">
                        <b>Please enter your First Name and Email Address to start the assessment.</b>
                    </Typography>
                </div>
            </div>
            <div className="container">
                <div>
                    <TextField.Styled
                        id="xxxf"
                        label="First Name"
                        margin="normal"
                        onBlur={handleFirstNameChange}
                        style={{ width: '510px', marginRight: '10px' }}
                    />
                </div>
                <div>
                    <TextField.Styled
                        id="xxxe"
                        label="Email Address"
                        margin="normal"
                        onChange={handleEmailChange}
                        style={{ width: '510px' }}
                    />
                </div>
				<div className="formdata">
					<div>
						<TextField.Styled
							id="first_name"
							label="First Name"
							margin="normal"
							style={{ width: '510px', marginRight: '10px' }}
						/>
					</div>
					<div>
						<TextField.Styled
							id="email"
							label="Email Address"
							margin="normal"
							style={{ width: '510px' }}
						/>
					</div>
				</div>
				<Fab.BlueFab
					style={{ marginTop: '20px', marginRight: '20px' }}
					variant="extended"
					size="medium"
					onClick={handlePrev}
				>
					Previous
				</Fab.BlueFab>

                <Fab.BlackFab
                    style={{ marginTop: '20px' }}
                    variant="extended"
                    size="medium"
                    onClick={props.onCompleted}
                    disabled={!firstNameValid || !emailValid}
                >
                    Start Assessment
                </Fab.BlackFab>
            </div>

        </>
    );
};
